<template>
  <ul class="v-breadcrumbs theme--light">
    <div v-for="(breadcrumb, index) in items" :key="`${index}-${breadcrumb.text}`">
      <li class="v-breadcrumbs__item" @click="$emit(breadcrumb.emitName)"
          v-bind:class="{ 'v-breadcrumbs__item--disabled':breadcrumb.disabled }">
        {{ breadcrumb.text }}
      </li>
      <li class="v-breadcrumbs__divider" v-if="index < items.length - 1">/</li>
    </div>
  </ul>
</template>

<script>

// DynameatBreadcrumbs has a property "emitName" to emit custom events depending on item
import Component from 'vue-class-component';
import { Name } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class DynameatBreadcrumbs extends Vue {
  @Name 'dynameat-breadcrumbs';

  @Prop({ Array, default: () => ([]), validator: (list = []) => list.every((item) => item.text && item.emitName) }) items;
}
</script>

<style>
.v-breadcrumbs__item {
  cursor: pointer;
}

.v-breadcrumbs__item--disabled {
  cursor: none;
}
</style>
